/**
 * `cx` — sınıf adlarını birleştirir.
 *
 * `clsx` bağımlılığı EKLENMEDİ: davranış on satır ve bu kadar merkezî bir
 * yerde ne yaptığını görebilmek bağımlılık tasarrufundan değerli
 * (`ConcurrencyPool`'da olduğu gibi).
 */
export type ClassValue = string | false | null | undefined;

export function cx(...values: readonly ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
